/**
 * @fileOverview 画布全局实例
 */
import { chooseComponent } from './interactUtil.js';
import {ContextMenu} from './contextmenu.js';
import SelectionArea from './viselect.mjs';
import './web-components.css';
import { cloneComponents, deleteComponents, pasteComponentsSameLevel, pasteComponentsDesignate} from './canvasCommon.js';
import i18next from "../global/i18n";

/**
 * 右键上下文菜单基础配置
 */
const menu = [
  {
    id: "contextMenuDelete",
    text: i18next.t('button.delete'),   // '删除'
    events: {
      click: () => {
        canvasGlobal.componentsSelected.forEach(prop => {
          deleteComponents(prop);
        });
      }
    }
  },
  {
    id: "contextMenuCopy",
    text: i18next.t('button.copy'),   // '复制'
    events: {
      click: () => {
        canvasGlobal.componentsSelected.forEach(component => {
          cloneComponents(component);
        });
      }
    }
  },
  {
    id: "contextMenuPasteAtSameLevel",
    text: i18next.t('button.pasteAtSameLevel'),   // '同层粘贴'
    events: {
      click: () => {
        pasteComponentsSameLevel();  // 粘贴函数，需要先复制才能粘贴
      }
    }
  },
  {
    id: "contextMenuPasteAtSpecifiedLocation",
    text: i18next.t('button.pasteAtSpecifiedLocation'),   // '指定粘贴'
    events: {
      click: () => {
        pasteComponentsDesignate();
      }
    }
  },
]

export const canvasGlobal = {
  componentsSelected: new Set<string>(), // 当前选中的组件列表（若用数组类型会有重复值）
  componentsHovered: [], // 当前悬浮的组件
  compList: [], // 当前全部的组件列表
  mouseX: 0,   // 点右键时，鼠标的X焦点
  mouseY: 0,   // 点右键时，鼠标的Y焦点
  prop: null,  // 复制的组件（复制操作中赋值，后面粘贴中需要用到）
  clickProp: null,// 点击的dom prop
  enable: true, // 是否启用框选
  dragging: false, // 当前是否正在执行拖拽框选/移动组件/调整组件大小
  contextMenu: new ContextMenu(menu), // 组件右键点击菜单
  selection: new SelectionArea({
    selectables: ['.comp-instanceT'], // 只有组件可被框选
    boundaries: ['.canvas'], // 框选区域为画布
    behaviour: {
      intersect: 'cover' // 要框选完这个组件才算是被选中，否则按住 ctrl 来框选子级元素时，父级或祖级也被选中了
    },
    features: {
      deselectOnBlur: true //点击画布其他区域时取消选中
    }
  })
    .on('beforestart', ev => {
      const { event: { ctrlKey, target, target: { id } } } = ev
      // console.log('selection beforestart ev :>> '/* , ev */)
      if (!canvasGlobal.componentsSelected.has(id)) { // 不在选中列表
        if (!ctrlKey) {
          chooseComponent(canvasGlobal.componentsSelected, false) // 若没按下 ctrl 键，则要清空选中列表
          canvasGlobal.selection.clearSelection()
        }
        chooseComponent([id], true)
      } else { // 在选中列表中
        chooseComponent([id], !ctrlKey) // 按 ctrl 键，对当前组件进行选中或反选
      }

      // 按住 ctrl 或者不是组件（comp-instanceT）才能能启动框选
      return canvasGlobal.enable && (ctrlKey || !target['classList'].contains('comp-instanceT')) // 按住 ctrl 键才能在 .comp-instanceT 中框选
    })
    // 框选工作之前触发
    .on('beforedrag', ev => {
      // console.log('selection beforedrag ev :>> '/* , ev */)
      chooseComponent(canvasGlobal.componentsSelected, false)
      canvasGlobal.selection.clearSelection()
      ev.selection.clearSelection(true, true)
      return canvasGlobal.enable
    })
    // start 事件不一定被触发
    .on('start', ev => {
      // console.log('selection start ev :>> '/* , ev */)
      const { store, event: { ctrlKey, metaKey } } = ev
      canvasGlobal.dragging = true
      if (!ctrlKey && !metaKey) { // Clear selection if no modifier key is pressed
        store.stored.forEach(el => el.classList.remove('selected'));
        canvasGlobal.selection.clearSelection()
      }
    })
    // move 事件不一定被触发
    .on('move', ev => {
      // console.log('selection move ev :>> '/* , ev */)
      const { event, store: { changed: { added, removed } } } = ev
      // 鼠标点击组件时会触发 move 事件，但只有鼠标移动了距离后（框选） ev.event 才不为 null
      canvasGlobal.dragging = true
      if (!event) return
      chooseComponent(added.map((el: HTMLElement) => el.id), true)
      chooseComponent(removed.map((el: HTMLElement) => el.id), false)
    })
    // stop 事件不一定被触发
    .on('stop', ev => {
      // console.log('selection stop ev :>> '/* , ev */)
      canvasGlobal.dragging = false
      const { componentsSelected } = canvasGlobal
      ev.store.selected
        .filter((el: HTMLElement) => el.classList.contains('selected'))
        .forEach((el: HTMLElement) => componentsSelected.add(el.id))
      canvasGlobal.compList.forEach(comp => {
        if (comp.selected && !componentsSelected.has(comp.uuid)) {
          comp.toggleSelect(false)
        }
      })
    })
}
